import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotraveller17SeaterOnRentShirdi() {



    const cardData = {





keyword: "Tempo Traveller 17 Seater on Rent Shirdi",

headingDescription: "Sai Shirdi Cab provides 17 Seater Tempo Traveller on Rent in Shirdi for families, pilgrimage groups, corporate teams, school groups, tour operators, and larger groups planning comfortable outstation travel from Shirdi. The 17-seater Tempo Traveller is suitable for group journeys where passengers prefer to travel together in one spacious vehicle instead of using multiple cars. Customers can hire the vehicle with an experienced driver for one-way trips, round trips, multi-day tours, pilgrimage journeys, family vacations, sightseeing trips, corporate outings, and customized outstation itineraries. Depending on the travel plan, groups from Shirdi can visit destinations such as Shani Shingnapur, Bhandardara, Igatpuri, Saptashrungi, Trimbakeshwar, Bhimashankar, Saputara, Mahabaleshwar, Ajanta-Ellora, and Nashik. Sai Shirdi Cab offers clean and well-maintained Tempo Travellers, experienced drivers, comfortable seating, luggage space, flexible pickup timings, and convenient group transportation for short and long-distance journeys.",

topPlaces: [
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a popular pilgrimage destination from Shirdi and is suitable for families, devotees, and organized groups. A 17-seater Tempo Traveller allows the entire group to travel together comfortably for a temple visit. Customers can arrange a convenient round trip from Shirdi with flexible pickup and return timings."
},
{
title: "Bhandardara",
description: "Bhandardara is a scenic destination known for its natural surroundings, lakes, hills, and peaceful atmosphere. Groups travelling from Shirdi can hire a 17-seater Tempo Traveller for a family outing, weekend trip, or group tour. The spacious vehicle is suitable for passengers carrying luggage and planning multiple sightseeing stops."
},
{
title: "Igatpuri",
description: "Igatpuri is a popular hill destination that can be included in an outstation journey from Shirdi. A 17-seater Tempo Traveller is convenient for families and larger groups travelling together for sightseeing and leisure. Customers can plan a round trip or multi-day itinerary with suitable stops along the route."
},
{
title: "Saptashrungi",
description: "Saptashrungi Devi Temple at Vani is an important pilgrimage destination that can be visited from Shirdi by a 17-seater Tempo Traveller. Devotees and families can travel together in one vehicle for a comfortable religious journey. The trip can also be combined with Nashik and other nearby pilgrimage destinations."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is a prominent Jyotirlinga destination that can be covered from Shirdi as part of a group pilgrimage tour. A 17-seater Tempo Traveller provides convenient transportation for devotees and families travelling together. Customers can combine Trimbakeshwar with Nashik or other religious locations."
},
{
title: "Bhimashankar",
description: "Bhimashankar is an important pilgrimage destination suitable for group travel from Shirdi. Customers can rent a 17-seater Tempo Traveller for a comfortable round trip, allowing the complete group to travel together. The itinerary can be customized for temple visits and additional sightseeing."
},
{
title: "Saputara",
description: "Saputara is a popular hill station suitable for family holidays, group tours, and weekend trips from Shirdi. A 17-seater Tempo Traveller provides convenient transportation for larger groups carrying luggage. Customers can arrange multi-day travel with sightseeing and hotel transfers according to their itinerary."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill station for family vacations, group outings, and leisure travel from Shirdi. Groups can hire a 17-seater Tempo Traveller to travel together comfortably. Multi-day rental is suitable for customers planning sightseeing, hotel stays, and visits to nearby attractions."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta and Ellora Caves are major heritage attractions that can be included in a group sightseeing trip from Shirdi. A 17-seater Tempo Traveller is suitable for families and tour groups who want to travel together with luggage. Full-day or multi-day itineraries can be customized according to sightseeing requirements."
},
{
title: "Nashik",
description: "Nashik is an important outstation destination from Shirdi for pilgrimage, sightseeing, family travel, and group tours. Customers can hire a 17-seater Tempo Traveller for comfortable group transportation to Nashik. The itinerary can also include Trimbakeshwar and other nearby attractions for a combined trip."
}
],









"services": [
{
"name": "Tempo Traveller 17 Seater On Rent Shirdi",
"description": "Tempo Traveller 17 Seater On Rent Shirdi provides spacious private transportation for families, friends, and larger groups traveling from Shirdi. The vehicle can be arranged for sightseeing, Sai Baba darshan, outstation journeys, airport transfers, railway station pickups, and customized group travel plans."
},
{
"name": "17 Seater Tempo Traveller on Rent in Shirdi",
"description": "17 Seater Tempo Traveller on Rent in Shirdi offers a convenient group travel option with comfortable seating and luggage capacity. It can be arranged for family outings, pilgrimage trips, sightseeing tours, weddings, corporate travel, and long-distance journeys according to the group's requirements."
},
{
"name": "17 Seater Tempo Traveller Rental Shirdi",
"description": "17 Seater Tempo Traveller Rental Shirdi provides a practical rental solution for groups requiring private transportation. Rental arrangements can be planned according to travel duration, passenger count, luggage requirements, pickup location, destination, and one-way or round-trip travel preferences."
},
{
"name": "17 Seater Tempo Traveller Hire Shirdi",
"description": "17 Seater Tempo Traveller Hire Shirdi is suitable for larger groups looking for spacious transportation for local and intercity travel. The vehicle can be hired for pilgrimage visits, family tours, sightseeing, corporate trips, wedding transportation, and outstation journeys."
},
{
"name": "17 Seater Tempo Traveller Booking Shirdi",
"description": "17 Seater Tempo Traveller Booking Shirdi allows groups to reserve suitable transportation in advance for planned journeys. Customers can provide travel dates, pickup timing, passenger count, luggage requirements, destination, rental duration, and preferred one-way or return arrangements."
},
{
"name": "17 Seater Tempo Traveller With Driver Shirdi",
"description": "17 Seater Tempo Traveller With Driver Shirdi provides chauffeur-driven group transportation for travelers who prefer convenient private travel. The vehicle can be arranged for sightseeing, Sai Baba darshan, family tours, airport transfers, railway station travel, and outstation trips."
},
{
"name": "17 Seater Traveller on Rent Shirdi",
"description": "17 Seater Traveller on Rent Shirdi offers a spacious vehicle option for groups traveling around Shirdi and toward nearby or distant destinations. It can be arranged for family trips, tourist tours, pilgrimage travel, events, corporate outings, and customized multi-stop itineraries."
},
{
"name": "17 Seater Tourist Vehicle Shirdi",
"description": "17 Seater Tourist Vehicle Shirdi provides comfortable group transportation for travelers exploring Shirdi and surrounding attractions. The vehicle can be used for sightseeing, temple visits, family outings, multi-destination tours, and planned travel schedules with convenient pickup and drop arrangements."
},
{
"name": "17 Seater Tempo Traveller for Outstation Shirdi",
"description": "17 Seater Tempo Traveller for Outstation Shirdi is designed for groups planning comfortable long-distance journeys from Shirdi to other cities and destinations. The trip can be organized according to the route, travel duration, group size, luggage, pickup point, and selected journey type."
},
{
"name": "17 Seater Tempo Traveller for Family Trip Shirdi",
"description": "17 Seater Tempo Traveller for Family Trip Shirdi provides spacious transportation for families traveling together with luggage and personal belongings. The vehicle can be arranged for pilgrimage journeys, sightseeing tours, holiday trips, family functions, and multi-day travel from Shirdi."
},
{
"name": "17 Seater Tempo Traveller for Wedding Shirdi",
"description": "17 Seater Tempo Traveller for Wedding Shirdi offers convenient group transportation for wedding guests and family members. The vehicle can be arranged for hotel transfers, venue transportation, railway station pickups, local movement, guest transfers, and travel between different wedding functions."
},
{
"name": "17 Seater Tempo Traveller for Corporate Trip Shirdi",
"description": "17 Seater Tempo Traveller for Corporate Trip Shirdi provides group transportation for employees, business teams, and corporate travelers. It can be arranged for company outings, meetings, conferences, team trips, airport transfers, intercity travel, and planned corporate itineraries."
},
{
"name": "17 Seater Tempo Traveller for Pilgrimage Shirdi",
"description": "17 Seater Tempo Traveller for Pilgrimage Shirdi provides comfortable transportation for groups of devotees visiting Shirdi and other religious destinations. The vehicle can be planned for Sai Baba darshan, temple tours, multi-destination pilgrimage routes, family groups, and customized religious travel schedules."
},
{
"name": "17 Seater Tempo Traveller for Tour Shirdi",
"description": "17 Seater Tempo Traveller for Tour Shirdi offers spacious private transportation for groups planning sightseeing and holiday journeys. Travelers can organize the vehicle for local attractions, nearby destinations, multi-day tours, family travel, and customized routes based on their preferred itinerary."
},
{
"name": "17 Seater Tempo Traveller One Way Shirdi",
"description": "17 Seater Tempo Traveller One Way Shirdi provides direct group transportation for passengers who require a single journey without arranging a return trip. The vehicle can be scheduled from the preferred pickup location in Shirdi to the selected destination according to the travel date and group requirements."
},
{
"name": "17 Seater Tempo Traveller Round Trip Shirdi",
"description": "17 Seater Tempo Traveller Round Trip Shirdi is suitable for groups planning an onward journey and return to Shirdi. The trip can be organized according to travel dates, stay duration, passenger count, luggage, waiting requirements, destinations, and preferred return schedule."
},
{
"name": "17 Seater Tempo Traveller Airport Pickup Shirdi",
"description": "17 Seater Tempo Traveller Airport Pickup Shirdi provides spacious group transportation for passengers arriving at an airport and continuing their journey toward Shirdi. Pickup arrangements can be coordinated with flight timings, luggage requirements, group size, airport location, and final destination."
},
{
"name": "17 Seater Tempo Traveller Railway Station Shirdi",
"description": "17 Seater Tempo Traveller Railway Station Shirdi offers convenient group transportation for passengers arriving at or departing from railway stations near Shirdi. The vehicle can be scheduled according to train timings, group size, luggage requirements, pickup location, and onward destination."
},
{
"name": "Affordable 17 Seater Tempo Traveller Shirdi",
"description": "Affordable 17 Seater Tempo Traveller Shirdi provides a practical group travel option for passengers seeking spacious transportation while managing their travel budget. The vehicle can be arranged according to journey distance, passenger count, luggage, travel duration, route, and one-way or round-trip requirements."
},
{
"name": "Best 17 Seater Tempo Traveller Rental Shirdi",
"description": "Best 17 Seater Tempo Traveller Rental Shirdi provides spacious private transportation for families, tourist groups, corporate teams, wedding guests, and pilgrimage travelers. Rental arrangements can be planned for local travel, sightseeing, events, outstation trips, airport transfers, and customized multi-day itineraries."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 17 Seater Tempo Traveller and other suitable vehicles for group transportation from Shirdi. Vehicles can be arranged for pilgrimage tours, family trips, weddings, corporate outings, sightseeing, airport transfers, railway station pickups, and outstation journeys according to group requirements."
}
],
"tableData": [
["Tempo Traveller 17 Seater On Rent Shirdi", "17 Seater Tempo Traveller on Rent in Shirdi"],
["17 Seater Tempo Traveller Rental Shirdi", "17 Seater Tempo Traveller Hire Shirdi"],
["17 Seater Tempo Traveller Booking Shirdi", "17 Seater Tempo Traveller With Driver Shirdi"],
["17 Seater Traveller on Rent Shirdi", "17 Seater Tourist Vehicle Shirdi"],
["17 Seater Tempo Traveller for Outstation Shirdi", "17 Seater Tempo Traveller for Family Trip Shirdi"],
["17 Seater Tempo Traveller for Wedding Shirdi", "17 Seater Tempo Traveller for Corporate Trip Shirdi"],
["17 Seater Tempo Traveller for Pilgrimage Shirdi", "17 Seater Tempo Traveller for Tour Shirdi"],
["17 Seater Tempo Traveller One Way Shirdi", "17 Seater Tempo Traveller Round Trip Shirdi"],
["17 Seater Tempo Traveller Airport Pickup Shirdi", "17 Seater Tempo Traveller Railway Station Shirdi"],
["Affordable 17 Seater Tempo Traveller Shirdi", "Best 17 Seater Tempo Traveller Rental Shirdi"],
["Sai Shirdi Cabs", "Tempo Traveller 17 Seater On Rent Shirdi"]
]
,







    whychoose: [
        { 
            WhyChooseheading: "17 Seater Tempo Traveller on Rent in Shirdi for Group Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides 17 Seater Tempo Traveller rental services in Shirdi for pilgrimage groups, families, friends, tourists, corporate teams, and other medium-sized groups. The vehicle can be arranged for Sai Baba Darshan, Shirdi sightseeing, railway station transfers, airport travel, outstation tours, and multi-day journeys where group members prefer to travel together." 
        }, 
        { 
            WhyChooseheading: "Spacious Transportation for Medium-Sized Groups", 
            WhyChoosedescription: "A 17 Seater Tempo Traveller is a convenient option for groups that need more seating capacity than a regular car or smaller vehicle. It allows passengers to travel together while managing their luggage and planned stops during local and long-distance journeys." 
        }, 
        { 
            WhyChooseheading: "17 Seater Tempo Traveller for Sai Baba Darshan", 
            WhyChoosedescription: "Pilgrimage groups can rent a 17 Seater Tempo Traveller for Sai Baba Darshan and visits to nearby religious destinations. Transportation can be planned around temple visits, hotel stays, sightseeing stops, and the group's preferred pilgrimage schedule." 
        }, 
        { 
            WhyChooseheading: "Shirdi Sightseeing by Tempo Traveller", 
            WhyChoosedescription: "Explore Shirdi and nearby attractions with your group in a private Tempo Traveller. Multiple sightseeing locations can be included in the travel plan according to your selected destinations, group schedule, and available time." 
        }, 
        { 
            WhyChooseheading: "Airport & Railway Station Transfers for Groups", 
            WhyChoosedescription: "Book a 17 Seater Tempo Traveller for group pickup and drop services from nearby airports and railway stations to Shirdi hotels, temples, event venues, or other destinations. Group transportation can be planned according to arrival and departure schedules." 
        }, 
        { 
            WhyChooseheading: "One-Way & Round-Trip Tempo Traveller", 
            WhyChoosedescription: "Choose one-way Tempo Traveller service when your group requires direct transportation to another destination, or arrange a round-trip vehicle when transportation is required for both onward and return journeys from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Outstation & Multi-Day Group Tours", 
            WhyChoosedescription: "The 17 Seater Tempo Traveller can be booked for outstation journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Trimbakeshwar, Shani Shingnapur, and other tourist or pilgrimage locations. Multi-day group tours can also be planned according to your itinerary." 
        }, 
        { 
            WhyChooseheading: "Book 17 Seater Tempo Traveller on Rent in Shirdi", 
            WhyChoosedescription: "Share your pickup location, destination, travel date, group size, luggage requirements, rental duration, sightseeing plans, one-way or round-trip preference, and travel schedule with Sai Shirdi Cabs to arrange a suitable 17 Seater Tempo Traveller." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I rent a 17 Seater Tempo Traveller in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides 17 Seater Tempo Traveller rental services in Shirdi for pilgrimage groups, families, tourists, corporate teams, and group tours." 
    }, 
    { 
        question: "Is a 17 Seater Tempo Traveller suitable for Sai Baba Darshan?", 
        answer: "Yes, a 17 Seater Tempo Traveller can be arranged for groups travelling to Sai Baba Temple and nearby pilgrimage destinations according to their travel itinerary." 
    }, 
    { 
        question: "Can I book a 17 Seater Tempo Traveller for Shirdi sightseeing?", 
        answer: "Yes, groups can book a private 17 Seater Tempo Traveller for Shirdi sightseeing and nearby attractions according to their preferred schedule." 
    }, 
    { 
        question: "Can I book a 17 Seater Tempo Traveller for airport transfers?", 
        answer: "Yes, a 17 Seater Tempo Traveller can be arranged for group airport pickup and drop services according to flight schedules and passenger requirements." 
    }, 
    { 
        question: "Can I book a 17 Seater Tempo Traveller from Shirdi Railway Station?", 
        answer: "Yes, railway station pickup and drop services can be arranged with a 17 Seater Tempo Traveller according to the train schedule and group requirements." 
    }, 
    { 
        question: "Can I rent a 17 Seater Tempo Traveller for one-way travel?", 
        answer: "Yes, one-way Tempo Traveller service can be arranged when a group needs direct transportation from Shirdi to another destination without requiring the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book a 17 Seater Tempo Traveller for a round trip?", 
        answer: "Yes, round-trip Tempo Traveller rental can be arranged for groups requiring transportation for both onward and return journeys from Shirdi." 
    }, 
    { 
        question: "Can I use a 17 Seater Tempo Traveller for outstation travel?", 
        answer: "Yes, the vehicle can be booked for outstation journeys to various cities, tourist destinations, and pilgrimage locations according to your group's travel plans." 
    }, 
    { 
        question: "Can I rent a 17 Seater Tempo Traveller for multiple days?", 
        answer: "Yes, multi-day Tempo Traveller arrangements can be discussed for extended pilgrimage tours, sightseeing trips, family vacations, group tours, and multi-city journeys." 
    }, 
    { 
        question: "How can I book a 17 Seater Tempo Traveller in Shirdi?", 
        answer: "Share your pickup point, destination, travel date, group size, luggage details, rental duration, sightseeing requirements, and one-way or return preference with Sai Shirdi Cabs to proceed with the booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Suresh More", 
        feedback: "Our group rented a 17 Seater Tempo Traveller in Shirdi for Sai Baba Darshan and nearby sightseeing. Having everyone travel together made the pilgrimage easier to organize and coordinate.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Anita Patil", 
        feedback: "We booked a 17 Seater Tempo Traveller for a multi-day family pilgrimage from Shirdi. The larger vehicle was convenient for our group and helped us travel together with our luggage.", 
        rating: 5 
    } 
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller 17 Seater On Rent Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/tempo-traveller-17-seater-on-rent-shirdi.webp",
  "description":
    "Book a Tempo Traveller 17 Seater on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group travel. Our 17 Seater Tempo Traveller is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimage travel, airport transfers, railway station transfers, one-way journeys, round trips, and outstation travel. Get a well-maintained vehicle with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/tempo-traveller-17-seater-on-rent-shirdi"
  }
};






    return (
        <div>


<Helmet>
  <title>Tempo Traveller 17 Seater On Rent Shirdi | 17 Seater Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 17 Seater Tempo Traveller on rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, family trips and outstation journeys. Get a spacious vehicle with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="Tempo Traveller 17 Seater On Rent Shirdi, 17 Seater Tempo Traveller on Rent in Shirdi, 17 Seater Tempo Traveller Rental Shirdi, 17 Seater Tempo Traveller Hire Shirdi, 17 Seater Tempo Traveller Booking Shirdi, 17 Seater Tempo Traveller with Driver Shirdi, 17 Seater Tempo Traveller Cab Shirdi, 17 Seater Tempo Traveller Taxi Shirdi, 17 Seater Tempo Traveller for Family Shirdi, 17 Seater Tempo Traveller for Group Shirdi, 17 Seater Tempo Traveller Outstation Shirdi, 17 Seater Tempo Traveller One Way Shirdi, 17 Seater Tempo Traveller Round Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotraveller17SeaterOnRentShirdi;